export default {
  "home.heading.default": "lec iekšā zvanā",
  "home.heading.loading": "Veram vaļā istabu...",
  "home.heading.join": "gatavs pievienoties?",
  "home.heading.joined": "esi iekšā",
  "home.heading.pending": "gaidām hostu",
  "home.body.default": "uztaisi istabu, iemet saiti, čilo.",
  "home.body.loading": "sekundi, ielādējam istabu.",
  "home.body.join": "pārbaudi kameru un miku, un lec iekšā.",
  "home.body.joined": "istaba ir gaisā. padalies ar saiti vai vienkārši sāc.",
  "home.body.joined_in_room": "esi istabā — lec iekšā vai padalies ar saiti.",
  "home.body.pending": "istaba ir slēgta. hosts tevi ielaidīs.",
  "home.cta.create": "Izveidot istabu",
  "home.cta.join": "Pievienoties",
  "home.cta.enter": "Ieiet istabā",
  "home.cta.creating": "Veidojam...",
  "home.cta.joining": "Pievienojamies...",
  "home.cta.opening": "Atveram...",
  "home.cta.pending": "Gaidām apstiprinājumu...",
  "home.copy_link": "kopēt saiti",
  "home.copied": "nokopēts!",
  "home.leave": "pamest istabu",
  "home.back": "atpakaļ",
  "home.no_participants": "te vēl neviena nav",
  "home.join_by_code": "pievienoties ar kodu",
  "home.code_placeholder": "ievadi kodu",
  "home.name_placeholder": "tavs vārds",
  "home.people_one": "cilvēks",
  "home.people_other": "cilvēki",
  "home.marketing.invite.title": "Uztaisi istabu,\npadalies ar saiti.",
  "home.marketing.invite.body": "Sāc ar vienu klikšķi. Aizsūti saiti draugiem un jebkurš var pievienoties — bez lejupielādēm un reģistrācijas.",
  "home.marketing.invite.preview_url": "yano.ai/ISTABA",
  "home.marketing.look.title": "Izskaties,\nkā gribi.",
  "home.marketing.look.body": "Krāsu filtri, mīkstināšana, vinjete — vai pilnībā aizmiglo seju. Tava kamera, tavs stils.",
  "home.marketing.host.title": "Tava telpa,\ntavi noteikumi.",
  "home.marketing.host.body": "Aizslēdz istabu, izslēdz kādam skaņu vai izmet pavisam. Hosts kontrolē situāciju.",
  "home.marketing.host.locked": "Istaba slēgta",
  "home.marketing.host.waiting_to_join": "Gaida rindā",
  "home.marketing.host.wants_to_join": "grib pievienoties",
  "home.marketing.anything.title": "Reāli jebkam.",
  "home.marketing.anything.body": "Mācībām, spēļu vakariem, darba standupiem, kopīgai skatīšanai — vai vienkārši čilam.",
  "home.marketing.use_case.study_group": "📚 mācību grupa",
  "home.marketing.use_case.game_night": "🎮 spēļu vakars",
  "home.marketing.use_case.standup": "💼 standups",
  "home.marketing.use_case.watch_party": "🍿 watch party",
  "home.marketing.use_case.catch_up": "☕ papļāpāt",
  "home.marketing.use_case.jam_session": "🎸 džems",
  "home.marketing.use_case.book_club": "📖 grāmatu klubs",
  "home.marketing.use_case.coworking": "💻 kopstrāde",
  "ended.heading": "zvans beidzies",
  "ended.left": "tu pameti istabu.",
  "ended.room_ended": "{title} tev ir beidzies.",
  "ended.rejoin": "pievienoties atkal",
  "ended.rejoining": "pievienojamies...",
  "ended.home": "atpakaļ uz sākumu",
  "call.connecting": "savienojam",
  "call.waiting": "gaidām pārējos",
  "call.invite_code": "ielūguma kods",
  "call.audio_on": "skaņa ieslēgta",
  "call.muted": "izslēgta skaņa",
  "call.listening": "Klausās",
  "call.audio_muted": "Skaņa izslēgta",
  "call.speaking": "runā",
  "call.you": "tu",
  "call.you_label": "Tu",
  "call.you_suffix": "(tu)",
  "call.chat_placeholder": "uzraksti ziņu...",
  "call.guest": "viesis",
  "call.room_fallback": "istaba",
  "call.focus_view": "Fokusa skats",
  "call.grid_view": "Režģa skats",
  "call.swap_main_video": "Mainīt galveno video",
  "call.open_chat": "Atvērt čatu",
  "call.close_chat": "Aizvērt čatu",
  "call.leave_room": "Pamest istabu",
  "call.confirm_leave": "Pamest?",
  "call.mic_on": "Miks ieslēgts",
  "call.muted_label": "Skaņa izslēgta",
  "call.camera_off": "Kamera izslēgta",
  "call.connect_failed": "Neizdevās savienoties — pārbaudi netu un mēģini vēlreiz.",
  "call.camera_access_failed": "Netiekam klāt kamerai. Pārbaudi pārlūka atļaujas un mēģini vēlreiz.",
  "call.recording_failed": "Neizdevās sākt ierakstu. Zvans turpināsies bez tā.",
  "call.initialize_failed": "Kaut kas nogāja greizi sākot zvanu. Pārlādē lapu un mēģini vēlreiz.",
  "call.participants": "Dalībnieki",
  "call.open_participants": "Atvērt dalībniekus",
  "call.close_participants": "Aizvērt dalībniekus",
  "call.lock_room": "Aizslēgt istabu",
  "call.unlock_room": "Atslēgt istabu",
  "call.locked": "aizslēgta",
  "call.unlocked": "atvērta",
  "call.kick_member": "Izmest no istabas",
  "call.mute_member": "Izslēgt skaņu",
  "call.unmute_member": "Ieslēgt skaņu",
  "call.muted_by_host": "Hosts izslēdza skaņu",
  "call.waiting_to_join": "Gaida, lai pievienotos",
  "call.approve": "Apstiprināt",
  "call.deny": "Noraidīt",
  "call.profile_actions": "Profila darbības",
  "call.profile_in_room": "Istabā",
  "call.profile_role_host": "Hosts",
  "call.profile_role_you": "Tu",
  "call.profile_action_mute": "Izslēgt viņam skaņu",
  "call.profile_action_mute_meta": "Tikai tev — viņš nezinās",
  "call.profile_action_dm": "1:1 DM",
  "call.profile_action_dm_meta": "Sāc privātu čatu",
  "call.profile_action_view": "Skatīt pilnu profilu",
  "call.profile_action_view_meta": "Bio, valodas, iepriekšējie zvani",
  "call.profile_action_report": "Ziņot",
  "call.profile_action_report_meta": "Atzīmēt moderācijai",
  "call.profile_sheet_close": "Aizvērt profila darbības",
  "call.profile_open_actions": "Atvērt profila darbības",
  "call.dm_title": "Privātā ziņa",
  "call.dm_back": "Atpakaļ uz darbībām",
  "call.dm_close": "Aizvērt privāto ziņu",
  "call.dm_status_online": "Online",
  "call.dm_in_room_with": "Šajā istabā",
  "call.dm_private_label": "Privāts čats",
  "call.dm_private_meta": "Tikai jūs abi redzat šīs ziņas",
  "call.dm_input_placeholder": "Sūti privātu ziņu…",
  "call.dm_send": "Sūtīt",
  "call.dm_just_now": "tikko",
  "call.dm_seen_just_now": "Redzēts tikko",
  "call.dm_typing": "{name} raksta…",
  "call.dm_minimize": "Minimizēt",
  "call.dm_active_indicator": "Atvērt sarunu",
  "call.dm_unread_messages": "{count} neizlasītas",
  "call.dm_toast_tap_to_open": "Spied, lai atvērtu",
  "call.dm_reopen_aria": "Atvērt sarunu ar {name}",
  "home.join_denied": "Hosts tevi neielaida.",
  "home.error.room_not_found": "Tāds istabas kods neeksistē.",
  "home.error.profile_required": "Aizpildi profilu, lai turpinātu.",
  "home.cta.set_up_profile": "Aizpildi profilu",
  "home.profile_trigger_new": "Spied, lai pievienotu info",
  "home.profile_trigger_new_aria": "Aizpildīt profilu",
  "home.profile_trigger_edit_aria": "Rediģēt profilu",
  "profile.eyebrow_new": "pasaki čau",
  "profile.eyebrow_edit": "tavs profils",
  "profile.title_new": "Uztaisi pa savam.",
  "profile.title_edit": "Rediģēt profilu",
  "profile.subtitle": "Pāris detaļas, lai citi zina, ar ko runā.",
  "profile.add_photo": "Pievienot bildi",
  "profile.add_photo_soon": "bildes būs drīz",
  "profile.photo_empty": "spied, lai pievienotu bildi",
  "profile.photo_ready": "bilde gatava",
  "profile.photo_save_first": "saglaba profilu pirms liec bildi",
  "profile.photo_crop_caption": "iekadrē bildi",
  "profile.photo_auto_caption": "pabīdi un pievelc, mēs saglabāsim automātiski",
  "profile.photo_upload": "Augšupielādēt bildi",
  "profile.photo_replace": "Nomainīt bildi",
  "profile.photo_remove": "Noņemt bildi",
  "profile.photo_cancel": "Atcelt",
  "profile.photo_save": "Saglabāt bildi",
  "profile.photo_uploading": "Lādējam bildi…",
  "profile.photo_removing": "Dzēšam bildi…",
  "profile.photo_choose_another": "Izvēlēties citu",
  "profile.photo_drag_hint": "Ievelc bildi aplī. Izmaiņas saglabājas automātiski.",
  "profile.photo_zoom": "Pievilkt",
  "profile.photo_horizontal": "Horizontāli",
  "profile.photo_vertical": "Vertikāli",
  "profile.name_label": "Vārds",
  "profile.name_placeholder": "Kā tevi saukt?",
  "profile.gender_label": "Es esmu",
  "profile.gender.woman": "Sieviete",
  "profile.gender.man": "Vīrietis",
  "profile.gender.unspecified": "Labāk neteikšu",
  "profile.bio_label": "Bio",
  "profile.bio_optional": "neobligāti",
  "profile.bio_placeholder": "Valodas, ko zini, kas tev patīk, jebkas…",
  "profile.cta_new": "Aiziet",
  "profile.cta_edit": "Saglabāt",
  "profile.saving": "Saglabājam…",
  "profile.close": "Aizvērt",
  "profile.error.save_failed": "Neizdevās saglabāt profilu. Mēģini vēlreiz.",
  "profile.error.avatar_invalid_type": "Izvēlies PNG, JPEG, GIF vai WebP bildi.",
  "profile.error.avatar_too_large": "Izvēlies bildi, kas mazāka par 5 MB.",
  "profile.error.avatar_too_small": "Izvēlies bildi, kas ir vismaz 96x96 pikseļi.",
  "profile.error.avatar_load_failed": "Nevarējām nolasīt šo bildi. Mēģini citu failu.",
  "profile.error.avatar_failed": "Neizdevās ielādēt bildi. Mēģini vēlreiz.",
  "profile.error.avatar_remove_failed": "Neizdevās noņemt bildi. Mēģini vēlreiz.",
  "effects.title": "Efekti",
  "effects.soft": "Mīksts fokuss",
  "effects.vignette": "Vinjete",
  "effects.face": "Aizmiglota seja",
  "effects.face_preview_only": "Aizmiglota seja (tikai priekšskatījums)",
  "effects.face_viewer_side": "Aizmiglota seja (skatītājiem)",
  "effects.face_strength": "Aizmiglojuma stiprums",
  "effects.grade.off": "OFF",
  "effects.grade.pop": "POP",
  "effects.grade.warm": "WARM",
  "effects.grade.cool": "COOL",
  "effects.grade.bw": "B&W",
  "camera.off": "kamera izslēgta",
  "camera.check": "pārbaudi kameru",
  "camera.retry": "mēģināt vēlreiz",
  "camera.ready": "kamera gatava",
  "camera.idle.title": "Ieslēdz kameru",
  "camera.idle.hint": "Mēs paprasīsim pārlūkam atļauju, kad būsi gatavs.",
  "camera.idle.button": "Ieslēgt kameru",
  "camera.status.idle": "Gaidām tevi",
  "camera.status.off": "Kamera ir izslēgta",
  "camera.status.loading": "Prasām pieeju kamerai...",
  "camera.status.denied": "Atļauj kameru pārlūkā un mēģini vēlreiz.",
  "camera.status.error": "Kameras priekšskatījums neizdevās. Mēģini vēlreiz.",
  "camera.status.unsupported": "Šis pārlūks neatbalsta kameru.",
  "camera.status.insecure": "Kamerai vajag HTTPS vai localhost.",
  "camera.status.attach_failed": "Neizdevās palaist kameru. Mēģini vēlreiz.",
  "camera.guest_name_placeholder": "Viesa vārds",
  "camera.flip": "Apgriezt kameru",
  "camera.save_name": "Saglabāt",
  "camera.edit_name": "Rediģēt vārdu",
  "mic.on": "Izslēgt mikrofonu",
  "mic.off": "Ieslēgt mikrofonu",
  "video.on": "Izslēgt kameru",
  "video.off": "Ieslēgt kameru",
  "chat.title": "čats",
  "chat.close": "Aizvērt čatu",
  "chat.loading": "lādējas...",
  "chat.load_earlier": "ielādēt iepriekšējās",
  "chat.empty": "te vēl nav ziņu",
  "chat.send_error": "Ziņa neaizgāja — mēģini vēlreiz.",
  "chat.input_placeholder": "raksti ziņu...",
  "room.host": "Hosts",
  "app.room_default_title": "Izveidot istabu",
  "app.chat_connection_rejected": "Čats nevarēja savienoties — pamēģini pārlādēt lapu.",
  "app.copy_failed": "Neizdevās nokopēt saiti. Pamēģini iezīmēt un nokopēt manuāli.",
  "app.chat_not_connected": "Čats vēl nav savienojies. Pagaidi mirkli un mēģini vēlreiz.",
  "footer.terms": "Noteikumi un nosacījumi",
  "footer.copyright": "© 2026 Yano.AI"
}
